module.exports = __webpack_public_path__ + "media/images/svg/mail-731581bb9d4db5aa00f291cba4640cb0.svg";